import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  Button,
  Grid,
  Box,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  Divider,
} from "@mui/material";
import ReactPerfectScrollbar from "react-perfect-scrollbar";
import GetAppIcon from "@mui/icons-material/GetApp";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ReusableTable = ({
  data = [],
  columns,
  headers = [],
  paginatedData,
  handleView,
  handleEdit,

  pdfData,
  redirectToBooking,
  handleOpenPopup,
  renderDeleteButton,
  renderEditButton,
  renderCustomViewButton,
  handleDownloadPDF,
  renderResendPaymentButton,
  renderPaymentUpdateButton,
  renderIndividualExportButton,
  renderBookingUpdateButton,
  title,
}) => {
  console.log("title",title)
  const tableHeaders = headers && headers.length > 0 ? headers : columns;
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  // const handleClickableCell = (header, item) => {
  //   if (header.isClickable && header.onClick) {
  //     const path = header.onClick(item);

  //     navigate(path);
  //   }
  // };
  console.log(title)
  const handleClickableCell = (header, item) => {
    if (header.isClickable && header.onClick) {
      const result = header.onClick(item);

      if (typeof result === "string") {
        // just a plain path
        navigate(result);
      } else if (result && typeof result === "object") {
        navigate(result.pathname, { state: result.state });
      }
    }
  };

  const handleMenuOpen = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(item);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedItem(null);
  };

  const handleMenuAction = (action) => {
    if (selectedItem) {
      action(selectedItem);
    }
    handleMenuClose();
  };

  // Function to render action buttons for bookings table
  const renderBookingActions = (item) => {
    const primaryActions = [];
    const menuActions = [];

    // Primary actions (always visible)
    if (renderCustomViewButton) {
      const viewButton = renderCustomViewButton(item);
      if (viewButton) {
        primaryActions.push(
          <Grid item key="view">
            {viewButton}
          </Grid>
        );
      }
    }

    if (renderResendPaymentButton) {
      const resendButton = renderResendPaymentButton(item);
      if (resendButton) {
        primaryActions.push(
          <Grid item key="resend">
            {resendButton}
          </Grid>
        );
      }
    }

    // Menu actions (in dropdown)
    if (renderEditButton) {
      const editButton = renderEditButton(item);
      if (editButton) {
        menuActions.push({
          label: "Edit",
          action: () => renderEditButton(item)?.props?.onClick?.(item),
          icon: null,
        });
      }
    }

    if (renderDeleteButton) {
      const deleteButton = renderDeleteButton(item);
      if (deleteButton) {
        menuActions.push({
          label: "Cancel",
          action: () => renderDeleteButton(item)?.props?.onClick?.(item),
          icon: null,
          color: "error",
        });
      }
    }

    if (renderIndividualExportButton) {
      const exportButton = renderIndividualExportButton(item);
      if (exportButton) {
        menuActions.push({
          label: "Export",
          action: () =>
            renderIndividualExportButton(item)?.props?.onClick?.(item),
          icon: null,
        });
      }
    }

    if (renderPaymentUpdateButton) {
      const paymentButton = renderPaymentUpdateButton(item);
      if (paymentButton) {
        menuActions.push({
          label: "Update Payment Status",
          action: () => renderPaymentUpdateButton(item)?.props?.onClick?.(item),
          icon: null,
        });
      }
    }

    if (
      renderBookingUpdateButton &&
      user?.user_type !== 2 &&
      user?.user_type !== 3
    ) {
      const bookingButton = renderBookingUpdateButton(item);
      if (bookingButton) {
        menuActions.push({
          label: "Update Booking Status",
          action: () => renderBookingUpdateButton(item)?.props?.onClick?.(item),
          icon: null,
        });
      }
    }

    return (
      <Box
        className="button-list"
        sx={{ display: "flex", alignItems: "center", gap: 1 }}
      >
        {/* Primary actions */}
        {primaryActions}

        {/* More actions menu */}
        {menuActions.length > 0 && (
          <Grid item>
            <IconButton
              size="small"
              onClick={(e) => handleMenuOpen(e, item)}
              sx={{
                border: "1px solid #ccc",
                borderRadius: "4px",
                width: "32px",
                height: "32px",
              }}
            >
              <MoreVertIcon fontSize="small" />
            </IconButton>
          </Grid>
        )}
      </Box>
    );
  };

  // Function to render regular actions for other tables
  const renderRegularActions = (item) => {
    return (
      <Box className="button-list">
        {handleView && (
          <Grid>
            <Button
              variant="outlined"
              color="warning"
              size="small"
              onClick={() => handleView(item)}
              className="view-user-button"
            >
              VIEW
            </Button>
          </Grid>
        )}

        {handleEdit && (
          <Grid item>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => handleEdit(item)}
              className="edit-user-button"
            >
              EDIT
            </Button>
          </Grid>
        )}

        {handleDownloadPDF && (
          <Grid>
            <Button
              variant="outlined"
              color="info"
              size="small"
              startIcon={<GetAppIcon />}
              onClick={() => handleDownloadPDF(item)}
              className="orange-button"
            >
              PDF
            </Button>
          </Grid>
        )}

        {handleOpenPopup && (
          <Grid item>
            {renderDeleteButton ? (
              renderDeleteButton(item, handleOpenPopup)
            ) : (
              <Button
                variant="outlined"
                color="error"
                size="small"
                onClick={() => handleOpenPopup(item)}
                className="delete-user-button"
              >
                DELETE
              </Button>
            )}
          </Grid>
        )}

        {title === "Customer" &&
          (user?.user_type === 1 ||
            user?.user_type === 2 ||
            user?.user_type === 4) && (
            <Grid item>
              <Button
                variant="outlined"
                size="small"
                onClick={() => redirectToBooking(item)}
                className="booknow-orange-button"
              >
                Book Now
              </Button>
            </Grid>
          )}
      </Box>
    );
  };

  return (
    <>
      <TableContainer component={Paper} sx={{ overflowY: "hidden" }}>
        <ReactPerfectScrollbar>
          <Table>
            <TableHead>
              <TableRow>
                {tableHeaders.map((col) => (
                  <TableCell key={col.field} className="table-fonts">
                    {col.header}
                  </TableCell>
                ))}
                {(handleView || handleEdit || handleOpenPopup) && (
                  <TableCell>Actions</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.length > 0 ? (
                paginatedData.map((item) => (
                  <TableRow key={item.id}>
                    {tableHeaders.map((col) => (
                      <TableCell
                        key={col.field}
                        className="table-cell-fonts"
                        onClick={() => handleClickableCell(col, item)}
                        style={{
                          cursor: col.isClickable ? "pointer" : "default",
                          textDecoration: col.isClickable
                            ? "underline"
                            : "none",
                        }}
                      >
                        {col.render
                          ? col.render(item[col.field], item)
                          : item[col.field] || "-"}
                      </TableCell>
                    ))}
                    {(handleView ||
                      handleEdit ||
                      handleOpenPopup ||
                      renderResendPaymentButton ||
                      renderIndividualExportButton) && (
                      <TableCell>
                        {title === "Bookings"
                          ? renderBookingActions(item)
                          : renderRegularActions(item)}
                      </TableCell>
                    )}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={tableHeaders.length + 1}>
                    <Typography
                      align="center"
                      color="textSecondary"
                      sx={{ py: 3 }}
                    >
                      No data available
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </ReactPerfectScrollbar>
      </TableContainer>

      {/* Actions Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          style: {
            minWidth: "160px",
          },
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        {selectedItem && (
          <>
            {/* Edit Action */}
            {renderEditButton && renderEditButton(selectedItem) && (
              <MenuItem
                onClick={() =>
                  handleMenuAction(() =>
                    renderEditButton(selectedItem)?.props?.onClick?.(
                      selectedItem
                    )
                  )
                }
                sx={{ fontSize: "14px" }}
              >
                Edit
              </MenuItem>
            )}

            {/* Export Action */}
            {renderIndividualExportButton &&
              renderIndividualExportButton(selectedItem) && (
                <MenuItem
                  onClick={() =>
                    handleMenuAction(() =>
                      renderIndividualExportButton(
                        selectedItem
                      )?.props?.onClick?.(selectedItem)
                    )
                  }
                  sx={{ fontSize: "14px" }}
                >
                  Export
                </MenuItem>
              )}

            {/* Payment Update Action */}
            {renderPaymentUpdateButton &&
              renderPaymentUpdateButton(selectedItem) && (
                <>
                  <Divider />
                  <MenuItem
                    onClick={() =>
                      handleMenuAction(() =>
                        renderPaymentUpdateButton(
                          selectedItem
                        )?.props?.onClick?.(selectedItem)
                      )
                    }
                    sx={{ fontSize: "14px" }}
                  >
                    Update Payment Status
                  </MenuItem>
                </>
              )}

            {/* Booking Status Update Action */}
            {renderBookingUpdateButton &&
              user?.user_type !== 2 &&
              user?.user_type !== 3 &&
              renderBookingUpdateButton(selectedItem) && (
                <MenuItem
                  onClick={() =>
                    handleMenuAction(() =>
                      renderBookingUpdateButton(selectedItem)?.props?.onClick?.(
                        selectedItem
                      )
                    )
                  }
                  sx={{ fontSize: "14px" }}
                >
                  Update Booking Status
                </MenuItem>
              )}

            {/* Cancel Action */}
            {renderDeleteButton && renderDeleteButton(selectedItem) && (
              <>
                <Divider />
                <MenuItem
                  onClick={() =>
                    handleMenuAction(() =>
                      renderDeleteButton(selectedItem)?.props?.onClick?.(
                        selectedItem
                      )
                    )
                  }
                  sx={{ fontSize: "14px", color: "error.main" }}
                >
                  Cancel
                </MenuItem>
              </>
            )}
          </>
        )}
      </Menu>
    </>
  );
};

export default ReusableTable;
